<template>
  <div id="content" class="internalAssessment previewNewAssessment">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="showConfirmDialog = false" @confirmed="transferToUser($event)" message="Are you sure? You will not have access to this anymore" ></ConfirmModal>


    <div class="container">
      <div class="assessment-navigation" v-if="internalAssessment">
        <div class="left">
          <div class="" v-if="internalAssessment._id">
            <div class="" v-if="$store.state.role != 'Admin'">
              <router-link v-if="internalAssessment.status == 'progress' || internalAssessment.status == 'draft'" :to="'/internalassessment_creation/'+internalAssessment._id.$oid+'?step='+this.stepback"  class="prev-button">
                  <v-img :src="require('@/assets/backArrowBlue.svg')" alt=""></v-img>
                  Back
              </router-link>
              <router-link v-else :to="'/assessment_results/'+internalAssessment._id.$oid" class="prev-button">
                  <v-img :src="require('@/assets/backArrowBlue.svg')" alt=""></v-img>
                  Back
              </router-link>
            </div>
            <div class="" v-else>
              <router-link v-if="internalAssessment.status == 'progress' || internalAssessment.status == 'draft'" :to="'/admin/internalassessment_creation/'+internalAssessment._id.$oid+'?step='+this.stepback"  class="prev-button">
                  <v-img :src="require('@/assets/backArrowBlue.svg')" alt=""></v-img>
                  Back
              </router-link>
            </div>

          </div>

          <span class="aname" v-if="internalAssessment.name"> {{ internalAssessment.name }}</span>
          <span class="aname" v-else>{{ $t("My assessment")}}</span>
          <div class="status inprogress" v-if="internalAssessment.status == 'progress'">
              <span class="status-text">{{ $t("In progress")}}</span>
          </div>
          <div class="status draft" v-if="internalAssessment.status == 'draft'">
              <span class="status-text">{{ $t("Draft")}}</span>
          </div>
          <div class="status completed" v-if="internalAssessment.status == 'completed'">
              <span class="status-text">{{ $t("Completed")}}</span>

          </div>
          <div class="status closed" v-if="internalAssessment.status == 'closed'">
              <span class="status-text">{{ $t("Closed")}}</span>

          </div>
          <div class="">
            <span class="deadlineTitle">{{ $t("Deadline : ")}}</span>
            <span class="deadlineValue">{{transformDate(deadlineDateFormated)}}</span>
          </div>
        </div>
        <div class="right">
           <button class="next-button" v-if='(internalAssessment.status == "draft" || internalAssessment.status == "progress") && $store.state.role != "Admin"' @click='sendInvit()'>
              Send
          </button>
          <button class="next-button" v-if='(internalAssessment.status == "draft" || internalAssessment.status == "progress") && $store.state.role == "Admin" && internalAssessment.createdFor' @click='showConfirmDialog=true'>
            {{$t("Transfer to Client")}}
         </button>
        </div>

    </div>
      <div class="internalAssessment_inner mt20">
        <div class="globalInfoAbout">

              <div class="description">
                  <div class="nopmargin" v-html="internalAssessment.description"></div>

              </div>
        </div>
        <div class="internalAssessmentContent2Col">
          <div class="row">
            <div class="col-12 col-xl-6">
              <div class="criterias">
                <span class="mainColTitle">{{ $t("Assessment criteria")}}</span>
                <div class="modifyBtn">
                  <router-link class="next-button_small" :to="'/internalassessment_creation/'+internalAssessment._id.$oid+'?step=2'" v-if="internalAssessment.status == 'draft' && $store.state.role != 'Admin'">
                      {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
                  </router-link>
                  <router-link class="next-button_small" :to="'/admin/internalassessment_creation/'+internalAssessment._id.$oid+'?step=2'" v-if="internalAssessment.status == 'draft' && $store.state.role == 'Admin'">
                      {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
                  </router-link>
                </div>
                <div class="criteriaList">

                  <div class="oneCriteria" v-for="(criteria,c) in internalAssessment.criterias" :key="c">
                    <div class="criteriaHead">
                      <div class="criteriaNameAndIcon">
                        <span class="criteriaName">{{criteria.name}}</span>
                        <v-img :src="require('@/assets/infoCriteria.svg')" @click="toggleDetailsSelected(c)" alt=""></v-img>
                        <CriteriaDetails v-click-outside="hideDetails" :hideGroup="true"  :criteria="criteria" :criteriaGroups="criteriaGroups" :hideEdit="true" v-if="showDetailsIndexInSelected === c"/>
                      </div>
                      <div class="dontGiveAValue">
                        <label :for="'selectAllFav'+c"  class="selectIt" @click="demoDisable[c] = !demoDisable[c];demoValue[c]=-1;">
                          <input class="checkbox__input" type="checkbox" value="true" :id="'selectAllFav'+c" >
                          <span class="criteriaName">{{ $t("I can’t assess")}}</span>
                        </label>
                      </div>
                    </div>
                    <div class="criteriaVoting">
                      <div class="myslider">
                        <v-slider v-model="demoValue[c]" min="1" max="5" step="1" thumb-size="30" thumb-label="always" color="#3982C4">
                          <template v-slot:prepend><span class="vsliderIndicator">1</span></template>
                          <template v-slot:append><span class="vsliderIndicator">5</span></template>
                        </v-slider>
                      </div>


                    </div>


                  </div>
                </div>
                <div class="feedBacks" v-if="!internalAssessment.disableFeedback">
                  <div class="row">
                    <div class="col-12  zone_input" v-if="internalAssessment.feedback_1">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_1 }}</span>
                      </div>
                      <textarea  class="innopearl_input" />
                    </div>
                    <div class="col-12 zone_input" v-if="internalAssessment.feedback_2">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_2 }}</span>
                      </div>
                      <textarea  class="innopearl_input" />
                    </div>
                    <div class="col-12 zone_input" v-if="internalAssessment.feedback_3">
                      <div class="zone_input_header">
                        <span class="zone_input_name">{{ internalAssessment.feedback_3 }}</span>
                      </div>
                      <textarea  class="innopearl_input" />
                    </div>

                  </div>

                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="judges">

                <span class="mainColTitle">{{ $t("Selected judges")}}</span>
                <div class="modifyBtn">
                  <router-link class="next-button_small" :to="'/internalassessment_creation/'+internalAssessment._id.$oid+'?step=5'" v-if="internalAssessment.status == 'draft'  && $store.state.role != 'Admin'">
                      {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
                  </router-link>
                  <router-link class="next-button_small" :to="'/admin/internalassessment_creation/'+internalAssessment._id.$oid+'?step=5'" v-if="internalAssessment.status == 'draft'  && $store.state.role == 'Admin'">
                      {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
                  </router-link>
                </div>
                <div class="judgesWithLicenses">
                  <span class="subTitleJudge">{{ $t(" Judges with licenses")}}</span>

                  <div class="listOfJudges  ">
                    <div class="oneJudgeSelected" v-for="(judge,c) in getJudgesWithLicenses()" :key="c">
                        <span class="criteriaName">{{judge.email}} </span>
                        <!-- <button class="remove" @click="removeJudge(judge)">
                          <v-img :src="require('@/assets/removeJudge.svg')" alt=""></v-img>
                        </button> -->
                    </div>
                  </div>

                </div>

                <div class="judgesWithoutLicences">
                  <span class="subTitleJudge">{{ $t("Judges without licenses")}}</span>
                  <div class="listOfJudges  ">

                    <div class="oneJudgeSelected" v-for="(judge,c) in getJudgesWithoutLicenses()" :key="c">
                        <span class="criteriaName">{{judge.email}} </span>
                        <!-- <button class="remove" @click="removeJudge(judge)">
                          <v-img :src="require('@/assets/removeJudge.svg')" alt=""></v-img>
                        </button> -->
                    </div>
                  </div>
                </div>

              </div>



            </div>
          </div>
        </div>
  <div class="selectedStartups">
    <div class="row text-center">
      <span class="titleText">{{ $t('Innovators to assess')}}</span>
    </div>
    <div class="modifyBtn centerBtn">
      <router-link class="next-button_small" :to="'/internalassessment_creation/'+internalAssessment._id.$oid+'?step=4'" v-if="internalAssessment.status == 'draft' && $store.state.role != 'Admin'">
          {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
      </router-link>
      <router-link class="next-button_small" :to="'/admin/internalassessment_creation/'+internalAssessment._id.$oid+'?step=4'" v-if="internalAssessment.status == 'draft' && $store.state.role == 'Admin'">
          {{$t('Modify')}} <img :src="require('@/assets/next.svg')" alt=""/>
      </router-link>
    </div>
        <div class="row listOfSelectedStartups">
          <div class="col-12 col-lg-6 col-xl-4  candidate" v-for="(candidate, c) in internalAssessment.startups" :key="c">
            <div class="candidate_card selectCandidateCard">
              <div class="candidate_card_head">
                <span class="name">{{candidate.name}}</span>

              </div>
              <div class="candidate_info_content">
                <span class="titreProperty">Value proposition</span>
                <span class="valueProperty" v-if="candidate.value_proposition">{{candidate.value_proposition}}</span>
                <span class="valueProperty" v-else>No data</span>

              </div>
              <div class="footer_link_cc">

                <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf" target="_blank" v-if="candidate._id" >
                  {{ $t("More details")}}

                </router-link>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
    </div>
  </div>
</template>
<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';
// import StartupInfoLine from '@/components/InfoStartupLine.vue'
//
// //import { Toaster, toast } from 'vue-sonner'
// import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
 import CriteriaDetails from '@/components/CriteriaDetail.vue'
 import ConfirmModal from '@/components/modals/ConfirmModal.vue'
 import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
    // QuillEditor,
    // CreateCriteriaModal,
     CriteriaDetails,
     ConfirmModal
  //  StartupInfoLine
  },
  name: 'InternalAssessmentPreview',
  data() {
    return {
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      showConfirmDialog:false,
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      stepback:1,
      showDetailsIndexInFav:null,
      internalAssessment : {
        type:"",
        name : "",
        project : null,
        deadline : null,
        description : "",
        criterias : [],
        disableFeedback : false,
        feedback_1 : "",
        feedback_2 : "",
        feedback_3 : "",
        startups : [],
        judges : []
      },

    }
  },
  methods:{
    sendInvit(){
      //on post l'assessment et le message
      // on met le message dans l'assessment comme ca il sera reafficher si on veut rajouter des juges plutard.
      //dans l'envoi on prend la liste des juges qui n'ont pas de licence (licenced == false)et a qui on n'a pas déjà envoyer le mail (mailSend == false)
      //apres envoi du mail on met mailSend a true pour le juge (comme ca il ne recoit pas de nouvelle notif si on renvoi une salve d'invit)
      // VERIFICATION NEEDS TO BE DONE BEFORE
      var error = false;
        //first check assessment type
      if(this.internalAssessment.type){
            if(this.internalAssessment.type == 'new'){
              if(this.internalAssessment.name.trim() == ""){
                toast.error(this.$t("Please enter an assessment name to proceed"));
                  error = true;
              }
            }
            if(this.internalAssessment.type == 'project'){
              if(!this.internalAssessment.project){
                toast.error(this.$t("PLease select your project"));
                error = true;
              }
            }
            if(!this.deadlineDateFormated){
              toast.error(this.$t("PLease select your deadline"));
              error = true;
            }
      }
      else{
        toast.error(this.$t("Please choose between new assessment or project assessment"));
        error = true;
      }


        //first check assessment type
        if(this.internalAssessment.criterias.length < 3){
          error = true;
          toast.error(this.$t("Please select at least 3 criterias to proceed"));
        }



        if(this.internalAssessment.disableFeedback == false){
          if(this.internalAssessment.feedback_1 == '' && this.internalAssessment.feedback_2 == '' && this.internalAssessment.feedback_3 == ''){
            toast.error(this.$t("Please complete the feedback domains or disable this requirement."));
            error = true;
          }
        }

        if(this.internalAssessment.startups.length == 0){
          error = true;
          toast.error(this.$t("Please select innovators to assess"));
        }

        if(this.internalAssessment.judges.length == 0){
          error = true;
          toast.error(this.$t("Please choose at least one judge to proceed"));
        }
        if(this.internalAssessment.guestJudges == true){
          if(!this.$refs.emailContentForAssessment){
            error =true;
            toast.error(this.$t("Please provide a message"));
          }

        }


      if(!error){
        //if no judge
        api.post(process.env.VUE_APP_API_URL+"/restrict/sendInvit",
          {
            assessment :this.internalAssessment,
            message: (this.$refs.emailContentForAssessment) ? this.$refs.emailContentForAssessment.getHTML() : ""
          },
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
            console.log("dfqsd",r.data);
            this.internalAssessment.status = "progress";
            toast.success(this.$t("Invitations to judges are sent successfully. You can view the Assessment results after the deadline."));


          }).catch( (e) => {
            console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }



    },
    transferToUser(){
      this.showConfirmDialog = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/transferAssessment",
        {
          assessment :this.internalAssessment,
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
          toast.success("Assessment transfer to user");
          setTimeout(() => {
            this.$router.push('/admin/manage_assessments');
          }, "1 seconde");



        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });

    },
    getJudgesWithLicenses(){
      var toret = this.internalAssessment.judges.filter(judge =>
           judge.licenced == true
      );
      console.log("toret",toret);
      return toret;
    },
    transformDate(dateString) {
 const date = new Date(dateString);
 const day = String(date.getDate()).padStart(2, '0');
 const month = String(date.getMonth() + 1).padStart(2, '0');
 const year = date.getFullYear();
 return `${day}/${month}/${year}`;
},
    getJudgesWithoutLicenses(){
      var toret = this.internalAssessment.judges.filter(judge =>
           judge.licenced == false
      );
      console.log("toret",toret);
      return toret;
    },
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    toggleDetailsSelected(index) {

      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
},
  mounted(){
    this.dict_loaded = false;
    // if(localStorage.getItem('currentFilterSet')){
    //   var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));
    //   this.selected_filters = fromCookie;
    // }
    this.stepback = this.$route.query.step;

    if(this.$route.params.id != "undefined"){
      api.get(process.env.VUE_APP_API_URL+"/restrict/assessment/"+this.$route.params.id).then( (r) => {
        this.internalAssessment = r.data;
        console.log("get",r.data);
        console.log(r);
        this.$nextTick(() => {
          if(this.$refs.linkplusContentEditor)this.$refs.linkplusContentEditor.setHTML(this.internalAssessment.description );
        });
        if(this.internalAssessment.deadline){

          this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
        }
        this.internalAssessment.criterias.forEach((item,i) => {
          console.log(item);
          this.demoValue[i] = 3;
          this.demoDisable[i] = false;
        });

      }).catch( (e) => console.log(e));
     }
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
       this.criteriaGroups = r.data;
       console.log("criterias : ",r.data);
       console.log(r);
     }).catch( (e) => console.log(e));

  },
  computed:{

},
watch:{

}

}
</script>
<style media="screen" scoped>
.internalAssessment{
  padding-top:50px;
  padding-bottom:50px;
}
.internalAssessment_inner{
    padding: 50px;
    padding-top:25px;
    border-radius: 10px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
        border-radius:10px;
}

.next-button_small {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    padding: 7px 20px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}
.prev-button {
    color: #3783C5;
    background: # 0% 0% no-repeat padding-box;
    padding: 10px 20px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        gap:5px;
        border-radius: 200px;
        border:1px solid #3783C5;
}
.next-button {
    color: #fff;
      border:1px solid #3783C5;
    background: #3783C5 0% 0% no-repeat padding-box;
        padding: 10px 20px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}

.status{
  gap:5px;
}
.status.inprogress {
    display: flex;
    align-items: center;
    background-color: #FFAA2A;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.inprogress .status-text {
    color: #fff;
    font-size: 14px;
}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #6C68A2;
      padding: 5px 20px !important;
    border-radius: 15px;
}


.status.draft .status-text {
    color: #fff;
    font-size: 14px;
}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #4ADE80;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.completed .status-text {
    color: #FFF;
    font-size: 14px;
}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #ADB3B5;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.closed .status-text {
    color: #fff;
    font-size: 14px;
}

.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .judges{
  padding:20px;
}
.internalAssessmentContent2Col .criterias{
  padding-left: 50px;
  padding-right: 50px;
  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}
.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.criteriaNameAndIcon{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
  justify-content: space-between;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#3783C5;
}

.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .myslider{
  width:100%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:10px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }
  .candidate_card_head .name{
    flex:1;
  }
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: #4c81c0;
    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }
</style>

<style media="screen">
  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid #3783C5 !important;
    color: #3783C5 !important;
  caret-color: #3783C5 !important;
  backdrop-filter: blur(40px);
  background-color: #3783C5 !important;
  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #DFE4F3 !important;
  color: #3783C5 !important;
  border: 1px solid #DFE4F3 !important;
  border-radius: 10px !important;
  font-weight: 500;
}

.previewNewAssessment .v-slider.v-input--horizontal .v-slider-track{
  height:6px !important;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-track__background {
  height:6px !important;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #C4CFEC !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

.listOfJudges{
  display:flex;
  gap:20px;
  margin-top:10px;
  flex-wrap: wrap;
}



.oneJudgeSelected{
  background:#480C831A;
  color:#480C83;
  padding:5px 20px;
  display:flex;
  gap:10px;
  border-radius: 200px;
  border: 1px solid #480C831A;
  position:relative;
}
.subTitleJudge{
  font-size:16px;
  font-weight: 700;
  color:#04246A;
  margin-bottom:10px;
  display:block;
  width:100%;
}

.judgesWithLicenses
{
    padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}
.judgesWithoutLicences{
  padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}

.oneInfoAboutValue p{
  padding:0;
  margin:0;
}
.modifyBtn.centerBtn{
  text-align:center;
}
.modifyBtn{
  width:100%;
  margin-top:20px;
  margin-bottom:20px;
}
.modifyBtn .next-button_small{
  margin:auto;
  display:inline-block;
}

.aname{
  color:#04246A;
}

.deadlineTitle{
  color:#04246A;
  text-transform: uppercase;
}
.deadlineValue{
  color:#3783C5;
}

.description{
  display:block;
  padding:50px;
  background:#3783C512;
  border-radius:20px;
  width:80%;

  margin:auto;
    margin-top:20px;
}
</style>
<style media="screen">
.nopmargin p{
  margin:0px !important;
  margin-bottom:0px !important;
    padding:0px !important;
}
</style>
